



import React, { useEffect, useState } from 'react';
import './Management.css';
import { FaTrash, FaEye } from 'react-icons/fa'; // Trash and View icon
import axios from 'axios';
// import './Management3.css'



const Management = () => {
  const [activeTab, setActiveTab] = useState('Order Life-Cycle');
  const [data, setData] = useState([]);
  const [orders, setOrders] = useState([]);
  const [total, setTotal] = useState(0);
  const [pending, setPending] = useState(0);
  const [closed, setClosed] = useState(0);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [year, setYear] = useState('');
  const [month, setMonth] = useState('');
  const [weekDay, setWeekDay] = useState('');
  const [specificDate, setSpecificDate] = useState('');
  const [vendorId, setVendorId] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const screenWidth = window.innerWidth;
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const containerHeight = window.innerWidth < 768
    ? '300px'       // Mobile
    : window.innerWidth < 850
      ? '300px'     // Below 850px
      : window.innerWidth < 1400
        ? '410px'   // Between 850px and 1399px
        : window.innerWidth < 1600
          ? '480px' // Between 1400px and 1599px
          : '640px'; // Above 1600px

  const getFilteredData = () => {
    return data.filter(item => {
      const orderDate = new Date(item.orderDateAndTime);

      if (year && orderDate.getFullYear().toString() !== year) return false;

      if (month) {
        const monthIndex = new Date(`${month} 1, 2000`).getMonth(); // Convert month name to index
        if (orderDate.getMonth() !== monthIndex) return false;
      }

      if (weekDay) {
        const orderDay = orderDate.toLocaleDateString('en-US', { weekday: 'short' }).toLowerCase();
        if (!orderDay.startsWith(weekDay.toLowerCase())) return false;
      }

      if (specificDate) {
        const formattedDate = orderDate.toLocaleDateString('en-GB'); // dd/mm/yyyy
        if (!formattedDate.includes(specificDate)) return false;
      }

      return true;
    });
  };

  const filteredData = getFilteredData();
  useEffect(() => {
    if (!vendorId) return; // prevent running if vendorId is null

    const fetchOrders = () => {
      const token = localStorage.getItem("authToken"); // ✅ Get token from localStorage
      if (!token) {
        console.warn("Auth token missing. Skipping order fetch.");
        return;
      }

      axios
        .get(
          `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // ✅ Send token in headers
            },
          }
        )
        .then((response) => {
          const processingOrders = response.data.filter((order) =>
            ['CONFIRMED'].includes(order.status)
          );
          setOrders(processingOrders);
        })
        .catch((error) => {
          console.error('Failed to fetch orders:', error.response?.data || error.message);
        });
    };

    fetchOrders(); // Initial fetch
    const intervalId = setInterval(fetchOrders, 1000); // Every 1 second

    return () => clearInterval(intervalId); // Cleanup
  }, [vendorId]);
  // runs again when vendorId changes


  const handleItemSelect = (orderId, index) => {
    setSelectedItems((prev) => {
      const existing = prev[orderId] || [];
      const updated = existing.includes(index)
        ? existing.filter((i) => i !== index)
        : [...existing, index];
      return { ...prev, [orderId]: updated };
    });
  };

  const handleSelectAll = (orderId, itemsLength) => {
    setSelectedItems((prev) => {
      const isAllSelected = prev[orderId]?.length === itemsLength;
      const newSelection = isAllSelected ? [] : [...Array(itemsLength).keys()];
      return { ...prev, [orderId]: newSelection };
    });
  };


  useEffect(() => {
    if (!vendorId) return; // Wait until vendorId is available

    const fetchTodayOrders = async () => {
      try {
        const token = localStorage.getItem("authToken"); // ✅ Get token from localStorage
        if (!token) {
          console.error("Authorization token is missing");
          return;
        }

        const response = await axios.get(
          `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // ✅ Attach token here
            },
          }
        );

        const allOrders = response.data;

        const todayStr = new Date().toISOString().split("T")[0];

        const todayFoodOrders = allOrders.filter((order) => {
          const orderDate = new Date(order.orderDateAndTime);
          const orderDateStr = orderDate.toISOString().split("T")[0];
          return order.appType === "Food" && orderDateStr === todayStr;
        });

        const pendingStatuses = [
          "pending",
          "confirmed",
          "waiting_for_pickup",
          "order_is_ready",
          "being_prepared",
          "processing",
        ];

        setTotal(todayFoodOrders.length);
        setPending(
          todayFoodOrders.filter((order) =>
            pendingStatuses.includes(order.status.toLowerCase())
          ).length
        );
        setClosed(
          todayFoodOrders.filter(
            (order) => order.status.toLowerCase() === "completed"
          ).length
        );
      } catch (error) {
        console.error("Error fetching today's orders:", error);
      }
    };

    fetchTodayOrders();
    const intervalId = setInterval(fetchTodayOrders, 3000); // refresh every 30 sec

    return () => clearInterval(intervalId);
  }, [vendorId]);


  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    if (storedVendorId) {
      setVendorId(storedVendorId);
    }
  }, []);


  useEffect(() => {
    if (!vendorId) return;

    const fetchData = () => {
      const token = localStorage.getItem("authToken"); // ✅ Retrieve token from storage
      if (!token) {
        console.warn("No auth token found. Skipping fetch.");
        return;
      }

      axios
        .get(
          `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // ✅ Include token in header
            },
          }
        )
        .then((res) => setData(res.data))
        .catch((err) =>
          console.error("Error fetching orders with token:", err.response?.data || err.message)
        );
    };

    fetchData(); // initial fetch

    const interval = setInterval(fetchData, 1000); // fetch every 1 second

    return () => clearInterval(interval); // cleanup
  }, [vendorId]);




  const [showDetails, setShowDetails] = useState(false);

  const orderStages = ["Accepted", "Delivered"];

  const styles = {
    card: { border: '1px solid #ccc', padding: '16px', margin: '16px', borderRadius: '10px', background: "linear-gradient(to right, #f46b45, #eea849)", },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    orderId: { margin: 0, fontWeight: "bold" },
    date: { fontSize: '18px', color: '#000', fontWeight: "bold" },
    pickupBtn: { background: '#28a745', color: '#fff', border: 'none', padding: '6px 12px', cursor: 'pointer', borderRadius: '5px', fontWeight: "bold", },
    tracker: { marginTop: '10px', display: 'flex', alignItems: 'center', fontWeight: "bold" },
    statusBox: { background: '#eee', padding: '8px 12px', borderRadius: '5px' },
    arrow: { margin: '0 5px' },
    dropdownBtn: {
      background: 'none',
      border: 'none',
      fontSize: '20px',
      cursor: 'pointer',
      ...(screenWidth >= 1000 && screenWidth <= 1200 ? { marginLeft: '100px' } : {}), // 👈 conditional style
    },
    itemList: { marginTop: '10px', fontWeight: "bold" },
    itemRow: { display: 'flex', justifyContent: 'space-between', padding: '4px 0', borderBottom: '1px solid #ddd' }
  };

  const handlePreparedClick = async (orderId) => {
    const token = localStorage.getItem("authToken"); // ✅ Retrieve token

    if (!token) {
      alert("Authorization token is missing");
      return;
    }

    try {
      const response = await axios.put(
        `https://backend.maamaas.com/food/api/orders/edit-orders/${orderId}/COMPLETED`,
        {
          status: "COMPLETED",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // ✅ Add token to headers
          },
        }
      );

      console.log("Order marked as ready:", response.data);

      // Update local UI
      setOrders((prev) =>
        prev.map((order) =>
          order.orderId === orderId ? { ...order, status: "COMPLETED" } : order
        )
      );
    } catch (error) {
      console.error("Failed to update to COMPLETED:", error.response?.data || error.message);
    }
  };


  // {=======================overview===============================}
  const tabContent = {
    "Order Life-Cycle": <div>
      {orders.map((order) => {
        const orderItems = order.order || [];
        const orderId = order.orderId;
        const selected = selectedItems[orderId] || [];

        return (
          <div key={orderId} style={styles.card}>
            <div style={styles.header}>
              <h3 style={styles.orderId}>Order ID: {orderId}</h3>
              <button style={styles.pickupBtn} className='pickup-btn-data'>
                {order.service || 'Service'}
              </button>
              <button
                style={styles.dropdownBtn}
                onClick={() =>
                  setShowDetails((prev) => ({
                    ...prev,
                    [orderId]: !prev[orderId],
                  }))
                }
              >
                {showDetails[orderId] ? '▲' : '▼'}
              </button>
            </div>

            {showDetails[orderId] && (
              <>
                <p style={styles.date}>
                  {order.orderDateAndTime ? (() => {
                    const dateObj = new Date(order.orderDateAndTime);
                    const date = dateObj.toLocaleDateString('en-IN', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                    });
                    const time = dateObj.toLocaleTimeString('en-IN', {
                      hour: '2-digit',
                      minute: '2-digit',
                      hour12: true,
                    });
                    return (
                      <>
                        <span style={{ color: 'black' }}>Date: </span>
                        <span style={{ color: 'white' }}>{date}</span>
                        <br />
                        <span style={{ color: 'black' }}>Time: </span>
                        <span style={{ color: 'white' }}>{time}</span>
                      </>
                    );
                  })() : 'N/A'}
                </p>

                <table
                  style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    marginTop: '1rem',
                  }}
                >
                  <thead>
                    <tr style={{ backgroundColor: '#b15cd6', textAlign: 'center' }}>
                      {/* <th style={{ padding: '8px', border: '1px solid #ddd' }}>
                      <input
                        type="checkbox"
                        checked={selected.length === orderItems.length}
                        onChange={() =>
                          handleSelectAll(orderId, orderItems.length)
                        }
                      />
                    </th> */}
                      <th style={{ padding: '8px', border: '1px solid #ddd' }}>S.No</th>
                      <th style={{ padding: '8px', border: '1px solid #ddd' }}>Item Name</th>
                      <th style={{ padding: '8px', border: '1px solid #ddd' }}>Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderItems.map((item, index) =>
                      item.status === "Okay" ? (
                        <tr
                          key={index}
                          style={{ borderBottom: '1px solid #eee', fontWeight: 'bold' }}
                        >
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                            {index + 1}
                          </td>
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                            {item.dishName}
                          </td>
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                            {item.quantity}
                          </td>
                        </tr>
                      ) : null
                    )}
                  </tbody>

                </table>
              </>
            )}

            <div
              style={{
                ...styles.tracker,
                display: 'flex',
                justifyContent: 'center',
                flexDirection: isMobile ? 'column' : 'row',
                gap: isMobile ? '5px' : '0px',
                alignItems: 'center',
              }}
            >
              {Array.isArray(orderStages) &&
                orderStages.map((stage, index) => (
                  <React.Fragment key={index}>
                    <div
                      onClick={() => {
                        if (stage === 'Delivered' && order.status === 'CONFIRMED') {
                          handlePreparedClick(order.orderId);
                        }
                      }}
                      style={{
                        ...styles.statusBox,
                        backgroundColor:
                          (order.status === 'CONFIRMED' && stage === 'Accepted') ||
                            (order.status === 'COMPLETED' && stage === 'Delivered')
                            ? 'green'
                            : '#f0f0f0',
                        color:
                          (order.status === 'CONFIRMED' && stage === 'Accepted') ||
                            (order.status === 'COMPLETED' && stage === 'Delivered')
                            ? 'white'
                            : 'black',
                        borderRadius: '6px',
                        padding: '8px 12px',
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        cursor: stage === 'Delivered' && order.status === 'CONFIRMED' ? 'pointer' : 'default'
                      }}
                    >
                      {stage}
                    </div>
                    {index !== orderStages.length - 1 && (
                      <span style={styles.arrow}></span>
                    )}
                  </React.Fragment>
                ))}
            </div>

          </div>

        );
      })}
    </div>
    ,
    Reports:
      <div style={{ scrollbarWidth: 'none', overflow: 'auto' }}>
        <div className="status-overview">
          <div style={{ background: "#3498db", color: "#fff", alignContent: "center" }} className="status-cardyy dine-in">
            <h4 style={{ display: 'flex', justifyContent: 'center', fontWeight: 'bold' }}>Food</h4>
            <p style={{ fontWeight: 'bold', display: 'flex', justifyContent: 'center' }}>Total: {total}</p>
            <p style={{ fontWeight: 'bold', display: 'flex', justifyContent: 'center' }}>Processing: {pending}</p>
            <p style={{ fontWeight: 'bold', display: 'flex', justifyContent: 'center' }}>Closed: {closed}</p>
          </div>
          <div style={{ background: "#3498db", color: "#fff", alignContent: "center" }} className="status-cardyy dine-in">
            <h4 style={{ display: 'flex', justifyContent: "center", fontWeight: "bold" }}>Rooms</h4>
            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Total: 20</p>
            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Pending: 4</p>
            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Closed: 4</p>

          </div>
          <div style={{ background: "#3498db", color: "#fff", alignContent: "center" }} className="status-cardyy dine-in">
            <h4 style={{ display: 'flex', justifyContent: "center", fontWeight: "bold" }}>Banquet Halls</h4>
            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Total: 20</p>
            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Pending: 4</p>
            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Closed: 4</p>

          </div>
          <div style={{ background: "#3498db", color: "#fff", alignContent: "center" }} className="status-cardyy dine-in">
            <h4 style={{ display: 'flex', justifyContent: "center", fontWeight: "bold" }}>Fashion</h4>
            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Total: 20</p>
            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Pending: 4</p>
            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Closed: 4</p>
          </div>

        </div>
        <div className="order-table-container">
          <style>
            {`
          .order-table-container {
            padding: 0px;
            font-family: Arial, sans-serif;
          }

          .filters {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            flex-wrap: wrap;
            gap: 10px;
            
            
          }

          .filters select {
            padding: 8px 10px;
            border-radius: 5px;
            border: 1px solid #ccc;
            margin-right: 10px;
            min-width: 120px;
            background-color: #b15cd6;
            color: #fff;
            font-weight:bold;
          }

          .filters button {
            padding: 10px 20px;
            background-color: #b15cd6;
            color: #fff;
            border: none;
            border-radius: 5px;
            font-weight: bold;
            cursor: pointer;
            white-space: nowrap;
          }

          .table-wrapper {
            overflow-x: auto;
            margin-top: 0px;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            min-width: 800px;
          }

          thead tr {
            background-color: #b15cd6;
          }

          th, td {
            padding: 10px;
            border: 1px solid #ddd;
            text-align: center;
            font-size: 14px;
          }

          tbody tr:nth-child(even) {
            background-color: #f9f9f9;
          }

          tbody tr:nth-child(odd) {
            background-color: #ffffff;
          }

          @media (max-width: 768px) {
            .filters {
              flex-direction: column;
              align-items: stretch;
            }

            .filters select {
              width: 100%;
              margin-right: 0;
            }

            .filters button {
              width: 100%;
              margin-top: 10px;
            }

            table {
              font-size: 12px;
            }
          }
        `}
          </style>

          {/* Filter Row */}
          <div className="filters">
            <div>
              <select onChange={(e) => setYear(e.target.value)}>
                <option value="">Yearly</option>
                <option value="2023">2023</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
              </select>

              <select onChange={(e) => setMonth(e.target.value)}>
                <option value="">Monthly</option>
                <option value="Apr">Apr</option>
                <option value="May">May</option>
                <option value="Jun">Jun</option>
                {/* Add more months as needed */}
              </select>

              <select onChange={(e) => setWeekDay(e.target.value)}>
                <option value="">Weekly</option>
                <option value="Sun">Sun</option>
                <option value="Mon">Mon</option>
                <option value="Tue">Tue</option>
                {/* Add more days if needed */}
              </select>

              <select onChange={(e) => setSpecificDate(e.target.value)}>
                <option value="">Today</option>
                <option value={new Date().toLocaleDateString('en-GB')}>
                  Today ({new Date().toLocaleDateString('en-GB')})
                </option>
                <option value={new Date(Date.now() - 86400000).toLocaleDateString('en-GB')}>
                  Yesterday ({new Date(Date.now() - 86400000).toLocaleDateString('en-GB')})
                </option>
                <option value="25/03/2025">25/03/2025</option>
                <option value="24/03/2025">24/03/2025</option>
              </select>
            </div>
            <button>Export</button>
          </div>

          {/* Table */}
          <div style={{ marginTop: "-15px" }} className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Order ID</th>
                  <th>Date</th>
                  <th>Category</th>
                  <th>Type</th>
                  <th>Name</th>
                  <th>Payment</th>
                  <th>Order Status</th>
                  <th>Amount</th>
                  <th>Ratings</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.orderId}</td>
                    <td>{new Date(item.orderDateAndTime).toLocaleDateString()}</td>
                    <td>Food</td>
                    <td>{item.orderType || item.orderService}</td>
                    <td>{item.userName || "-"}</td>
                    <td>{item.paymentMethod}</td>
                    <td>{item.status}</td>
                    <td>₹{Math.round(item.grandTotal)}</td>
                    <td>★ ★ ★</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>


  };

  return (


    <div>

      <style>{`
        .main-container {
          padding: 20px;
          display: flex;
          flex-direction: column;
         
        }

         .tabs-wrapperyyy {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          margin-left:0px;
          margin-top:-46px;
}
// .left-column {
//             width: 100%;
//             padding-right: 140px;
//             max-height: 700px;
           
//           }


/* Mobile view ke liye (max-width 768px ya 600px aapke design ke hisaab se) */
@media screen and (max-width: 768px) {
  .tabs-wrapper {
    margin-left: 0;
    
  }
}


        .tab-buttons {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 10px;
          margin-top:42px;
         
        }

        .tab-button {
          border: none;
          border-radius: 10px;
          width: 150px;
          height: 40px;
          background-color: #d9d9d9;
          color: #000;
          font-weight: bold;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }

        .tab-button.active {
          background-color: #b15cd6;
        }

        .tab-content {
          margin-top: 20px;
          width: 100%;
          max-width:944px;
          
        }

        .sidebar {
          margin-top: 30px;
          max-height: 600px;
          overflow-y: auto;
        }

        .card {
          width: 100%;
          max-width: 300px;
          height: 120px;
          background: #ccc;
          border-radius: 8px;
          box-shadow: 0px 2px 4px rgba(0,0,0,0.1);
          margin: 10px auto;
          position: relative;
          padding: 10px;
        }

        .card h5, .card p {
          color: white;
          margin: -18 !imortanant;
        }

        

        
        @media (min-width: 768px) {
          .main-container {
            flex-direction: row;
            justify-content: space-between;
          }


         .left-column {
    padding-right: 0;
    display: flex;
    flex-direction: column;         /* stack children vertically */
           
    justify-content: center;        /* center vertically */
    text-align: center;
    margin: 0 auto;
  }

          .right-column {
            width: 30%;
            position: sticky;
            top: -30px;
            max-height: 700px;
            overflow-y: auto;
          }

          .card {
            margin-left: 0;
          }
            .tabs-wrapperyyy{
            margin-left:none

            }

        }

        /* Hide native scrollbars */
        .sidebar::-webkit-scrollbar,
        .left-column::-webkit-scrollbar {
          width: 0px;
          background: transparent;
        }
      `}</style>

      <div className="container-fluid">
        <div className="row">
          {/* <div className="col-lg-2 col-md-12 col-sm-12 col-12"></div> */}
          <div className="col-lg-12 col-md-12 col-sm-12 col-12">


            {/* Left Section */}
            <div className="left-column" style={{}}>
              <div className="tabs-wrapperyyy ">

                <div className="tab-buttons" style={{}}>
                  {Object.keys(tabContent).map((label) => (
                    <button
                      key={label}
                      className={`tab-button ${activeTab === label ? "active" : ""}`}
                      onClick={() => setActiveTab(label)}
                    >
                      {label}
                    </button>
                  ))}
                </div>
                <div className="tab-content" style={{
                  overflow: 'auto', 
                  height: window.innerHeight<400 ? "50vh" :window.innerHeight<500 ? "55vh" : window.innerHeight<600 ? "60vh" : containerHeight,
                  scrollbarWidth: "none",
                  msOverflowStyle: "none", maxWidth: '944px',
                }}>{tabContent[activeTab]}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};


export default Management;